import React from "react";
import FirstComponent from "./Web/FirstComponent";
import Second from "./Web/Second";
import Third from "./Web/Third";
import Fourth from "./Web/Fourth";

const WebService = () => {
  return (
    <>
      <FirstComponent />
      <Second />
      <Third />
      <Fourth />
    </>
  );
};

export default WebService;
